import { Center, Grid, GridItem } from '@chakra-ui/react'
import PropTypes from 'prop-types'

export const WorkerLayout = ({ children }) => {
    return (
        <Grid
            minH="100vh"
            gridTemplateRows="1fr var(--footer-height)"
            sx={{
                '--header-height': '40px',
                '--footer-height': '25px',
            }}
        >
            <GridItem>{children}</GridItem>
            <Center
                as="footer"
                bg="tryt.gray-2"
                fontSize="xs"
                position="sticky"
                bottom={0}
            >
                © TRYT Career ,Inc.
            </Center>
        </Grid>
    )
}
WorkerLayout.propTypes = {
    children: PropTypes.node.isRequired,
}
